import type { Configuration } from '@gov-nx/api/configuration/configuration.types';
import { GovError } from '@gov-nx/core/app/error/gov-error';
import { useConfigurationStore } from '@gov-nx/store/configuration/store';

export const useConfiguration = (): Configuration => {
	const configuration = useConfigurationStore('configuration');

	if (!configuration) {
		throw new GovError('[GOV] configuration not loaded yet');
	}

	return configuration;
};
